export var Popups;

(function (Popups) {
  Popups["Success"] = "Success";
  Popups["Info"] = "Info";
  Popups["Error"] = "Error";
  Popups["Confirm"] = "Confirm";
  Popups["Default"] = "Default";
})(Popups || (Popups = {}));